import React from "react";
import UnitCountSeven from "./child/UnitCountSeven";
import AssetsByCategory from "./child/AssetsByCategory";
import AssetsByCondition from "./child/AssetsByCondition";
import RecentAssets from "./child/RecentAssets";

const DashBoardLayerTen = () => {
  return (
    <div className='row gy-4'>
      {/* Asset Statistics Cards */}
      <UnitCountSeven />

      {/* Assets by Condition Chart */}
      <AssetsByCondition />

      {/* Assets by Category Chart */}
      <AssetsByCategory />

      {/* Recent Assets Table */}
      <RecentAssets />
    </div>
  );
};

export default DashBoardLayerTen;
